import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../store/types";

// Root selectors
const getMetricsState = (state: RootState) => state.metrics;

export const getQueueMetricsSelector = createSelector(
  [getMetricsState],
  (metrics) => metrics?.queueMetrics,
);

export const getMyMetricsDataSelector = createSelector(
  [getMetricsState],
  (metrics) => metrics?.myMetricsData,
);
